import PropTypes from 'prop-types';
import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as contextmenu from 'components/ContextMenu';
import TFIAccountIcon from 'notebook/tfi/TFIAccountIcon';
import TFIActions from 'notebook/tfi/TFIActions';
import {AccountType} from 'notebook/tfi/TFIConstants';
import TFIUtil from 'notebook/tfi/TFIUtil';
import SidebarItem from 'sidebar/SidebarItem';
import * as modals from 'util/Modals';
import {ElementMouseEvent} from 'util/Types';

interface TFIAccountShape {
  id: string;
  accountType: AccountType;
  name: string;
}

const TFI_ACCOUNT_SHAPE: PropTypes.Requireable<TFIAccountShape> = PropTypes.shape({
  id: PropTypes.string.isRequired,
  accountType: PropTypes.oneOf(Object.values(AccountType)).isRequired,
  name: PropTypes.string.isRequired,
});
export {TFI_ACCOUNT_SHAPE};

interface Props {
  tfiAccount: TFIAccountShape;
}

class TFIAccountItem extends React.Component<Props> {
  openTFIAccount = (): void => {
    // Accounts use the same ID for both folder and account IDs
    TFIActions.listFolder(this.props.tfiAccount.id, this.props.tfiAccount.id);
    analytics.track('tfi', 'listed_folder', {accountType: this.props.tfiAccount.accountType});
  };

  openTFIAccountContextMenu = (e: ElementMouseEvent): void => {
    contextmenu.view.open(e.nativeEvent, [
      {
        name: 'Unlink Account',
        click: () => {
          const readableType = TFIUtil.readableAccountType(this.props.tfiAccount.accountType);
          const component = (
            <div>
              <p>
                {`Are you sure you want to unlink your ${readableType} account `}
                <strong>{this.props.tfiAccount.name}</strong>?
              </p>
              <p>
                {`All files you've imported from the account into Benchling projects will remain there, \
  but you'll lose the ability to resync them.`}
              </p>
            </div>
          );
          modals
            .confirm('Unlink Account', component, 'success', {
              acceptText: 'Yes, unlink',
              rejectText: 'No, never mind',
            })
            .done(TFIActions.deleteAccount.bind(null, this.props.tfiAccount.id));
        },
      },
    ]);
  };

  render(): JSX.Element {
    return (
      <SidebarItem
        clickHandler={this.openTFIAccount}
        contextMenuHandler={this.openTFIAccountContextMenu}
        icon={React.createElement(
          'span',
          {className: 'result-icon tfi-result-icon'},
          <TFIAccountIcon accountType={this.props.tfiAccount.accountType} />
        )}
        name={this.props.tfiAccount.name}
      />
    );
  }
}

export default TFIAccountItem;
